<template>
  <div class="finance-page">
    <main class="page-content">
      <section class="section quick-section">
        <h2>快捷操作</h2>
        <div class="quick-grid">
          <button class="quick-item" type="button" @click="$router.push('/mobile/finance/report')">
            <span class="quick-icon report-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M9 19v-6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm0 0V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v10m-6 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2m0 0V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z" />
              </svg>
            </span>
            <span>财务报表</span>
            <span class="arrow">›</span>
          </button>
          <button class="quick-item" type="button" @click="$router.push('/mobile/finance/cashflow')">
            <span class="quick-icon cash-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
              </svg>
            </span>
            <span>资金流水</span>
            <span class="arrow">›</span>
          </button>
          <button class="quick-item" type="button" @click="$router.push('/mobile/finance/receivable')">
            <span class="quick-icon receive-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M17 9V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2m2 4h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2zm7-5a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
              </svg>
            </span>
            <span>应收账款</span>
            <span class="arrow">›</span>
          </button>
          <button class="quick-item" type="button" @click="$router.push('/mobile/finance/payable')">
            <span class="quick-icon pay-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3z" />
              </svg>
            </span>
            <span>应付账款</span>
            <span class="arrow">›</span>
          </button>
        </div>
      </section>

      <section class="section">
        <h2>收付款管理</h2>
        <div class="management-card">
          <div class="management-row receive-row">
            <div class="management-info">
              <span class="round-icon receive-icon">↓</span>
              <div class="management-summary">
                <strong>待收</strong>
                <span class="amount receive-amount">¥{{ formatAmount(overview.netReceivable) }}</span>
                <small>{{ overview.monthlyReceivable ? '本月新增' : '暂无新增' }}</small>
              </div>
            </div>
            <button class="row-action" type="button" @click="handleCreateReceipt">
              新建收款单 <b>›</b>
            </button>
            <button class="row-action" type="button" @click="handleViewReceiptList">
              收款单列表 <b>›</b>
            </button>
          </div>
          <div class="management-row pay-row">
            <div class="management-info">
              <span class="round-icon pay-icon">↑</span>
              <div class="management-summary">
                <strong>待付</strong>
                <span class="amount pay-amount">¥{{ formatAmount(overview.netPayable) }}</span>
                <small>{{ overview.monthlyPayable ? '本月新增' : '暂无新增' }}</small>
              </div>
            </div>
            <button class="row-action" type="button" @click="handleCreatePayment">
              新建付款单 <b>›</b>
            </button>
            <button class="row-action" type="button" @click="handleViewPaymentList">
              付款单列表 <b>›</b>
            </button>
          </div>
        </div>
      </section>

      <section class="section">
        <h2>核销单管理</h2>
        <div class="writeoff-card">
          <div class="writeoff-actions">
            <div class="writeoff-cell writeoff-cell-left" @click="$router.push('/mobile/finance/writeoff/add')">
              <div class="writeoff-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 14l2 2 4-4M7 7h10M7 11h6m-8 9h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z" />
                </svg>
              </div>
              <span class="writeoff-text">新建核销单</span>
            </div>
            <div class="writeoff-cell writeoff-cell-right" @click="$router.push('/mobile/finance/writeoff/list')">
              <span class="writeoff-text">核销单列表</span>
            </div>
          </div>
        </div>
      </section>

      <section class="section transactions-section">
        <div class="section-title">
          <h2>最近交易</h2>
          <button type="button" @click="$router.push('/mobile/finance/transactions')">查看全部</button>
        </div>
        <div v-if="recentTransactions.length" class="transaction-list">
          <div v-for="transaction in recentTransactions" :key="transaction.id" class="transaction-item">
            <span :class="['transaction-icon', transaction.type === 'income' ? 'income-icon' : 'expense-icon']">
              {{ transaction.type === 'income' ? '↓' : '↑' }}
            </span>
            <div class="transaction-info">
              <strong>{{ transaction.description }}</strong>
              <small>{{ transaction.category || '资金流水' }} · {{ transaction.date }}</small>
              <small class="transaction-no">{{ transaction.account }}</small>
            </div>
            <div class="transaction-value">
              <strong :class="transaction.type === 'income' ? 'receive-amount' : 'expense-amount'">
                {{ transaction.type === 'income' ? '+' : '-' }}¥{{ formatAmount(transaction.amount) }}
              </strong>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">暂无最近交易</div>
      </section>
    </main>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { companyFinanceApi, financeReportApi } from '@/api/api'
import dayjs from 'dayjs'

const router = useRouter()
const selectedPeriod = ref('7d')
const overview = ref({
  monthlyReceivable: 0,
  netReceivable: 0,
  monthlyPayable: 0,
  netPayable: 0,
  monthlySales: 0,
  salesOrderCount: 0,
  monthlyPurchase: 0,
  purchaseOrderCount: 0
})
const recentTransactions = ref([])

const formatAmount = value => Number(value || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

const computeDateRange = () => {
  const map = { '7d': 7, '30d': 30, '90d': 90 }
  const days = map[selectedPeriod.value] || 7
  return {
    startDate: dayjs().subtract(days - 1, 'day').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD')
  }
}

const loadOverview = async () => {
  try {
    const [receivableRes, payableRes, salesRes, purchaseRes] = await Promise.all([
      financeReportApi.getMonthlyReceivable(),
      financeReportApi.getMonthlyPayable(),
      financeReportApi.getMonthlySales(),
      financeReportApi.getMonthlyPurchase()
    ])
    if (receivableRes?.success && receivableRes.data) {
      overview.value.monthlyReceivable = Number(receivableRes.data.monthlyIncrease || 0)
      overview.value.netReceivable = Number(receivableRes.data.netReceivable || 0)
    }
    if (payableRes?.success && payableRes.data) {
      overview.value.monthlyPayable = Number(payableRes.data.monthlyIncrease || 0)
      overview.value.netPayable = Number(payableRes.data.netPayable || 0)
    }
    if (salesRes?.success && salesRes.data) {
      overview.value.monthlySales = Number(salesRes.data.totalSales || 0)
      overview.value.salesOrderCount = Number(salesRes.data.orderCount || 0)
    }
    if (purchaseRes?.success && purchaseRes.data) {
      overview.value.monthlyPurchase = Number(purchaseRes.data.totalPurchase || 0)
      overview.value.purchaseOrderCount = Number(purchaseRes.data.orderCount || 0)
    }
  } catch (error) {
    console.error('获取财务概览数据失败', error)
  }
}

const mapFlowToTransaction = item => ({
  id: item.id,
  type: item.flowTypeName === '收入' || item.flowType === 1 ? 'income' : 'expense',
  description: item.businessTypeName || item.remarks || '资金流水',
  category: item.accountName || '',
  amount: Number(item.amount || 0),
  date: item.createdOn ? dayjs(item.createdOn).format('MM-DD HH:mm') : '',
  account: item.businessNo || ''
})

const loadRecentTransactions = async () => {
  const { startDate, endDate } = computeDateRange()
  try {
    const params = {
      pagination: { current: 1, pageSize: 10 },
      search: { flowNo: '', accountName: '', flowType: '', businessType: '', startDate, endDate },
      sort: { predicate: 'createdOn', reverse: true }
    }
    const res = await companyFinanceApi.getFundFlowList(params)
    if (res?.success && res.data) {
      recentTransactions.value = Array.isArray(res.data.list) ? res.data.list.map(mapFlowToTransaction).slice(0, 4) : []
    }
  } catch (error) {
    console.error('获取最近交易失败', error)
  }
}

const handleCreateReceipt = () => router.push('/mobile/finance/receipt/add')
const handleViewReceiptList = () => router.push('/mobile/finance/receipt/list')
const handleCreatePayment = () => router.push('/mobile/finance/payment/add')
const handleViewPaymentList = () => router.push('/mobile/finance/payment/list')

onMounted(() => Promise.all([loadOverview(), loadRecentTransactions()]))
watch(selectedPeriod, () => Promise.all([loadOverview(), loadRecentTransactions()]))
</script>

<style scoped>
.finance-page {
  min-height: 100vh;
  background: #f7f8fa;
  color: #20242b;
  padding-bottom: 18px;
}
.page-content { padding: 0 16px; }
.section { margin-top: 20px; }
.section h2 { margin: 0 0 11px 2px; font-size: 16px; line-height: 22px; font-weight: 700; }
.quick-grid, .management-card, .writeoff-card {
  background: #fff; border: 1px solid #e5e7eb; border-radius: 5px; overflow: hidden;
}
.quick-grid { display: grid; grid-template-columns: 1fr 1fr; }
.quick-item {
  height: 58px; padding: 0 12px; display: flex; align-items: center; gap: 10px;
  background: #fff; border: 0; border-bottom: 1px solid #edf0f2; color: #343942; font-size: 13px; text-align: left;
}
.quick-item:nth-child(odd) { border-right: 1px solid #edf0f2; }
.quick-item:nth-last-child(-n+2) { border-bottom: 0; }
.quick-item:active, .row-action:active { background: #f5f7fa; }
.quick-icon { width: 25px; height: 25px; display: inline-flex; align-items: center; justify-content: center; border-radius: 4px; color: #fff; font-size: 15px; font-weight: 600; }
.quick-icon svg { width: 16px; height: 16px; }
.report-icon { background: #497edc; } .cash-icon { background: #3ba878; }
.receive-icon { background: #3ba878; } .pay-icon { background: #4d7fdc; }
.arrow { margin-left: auto; font-size: 21px; color: #9298a1; font-weight: 300; }
.management-row {
  height: 82px;
  padding: 0 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
}
.management-row > .row-action + .row-action { border-left: 0; padding-left: 8px; }
.management-row > .row-action:first-of-type { border-left: 1px solid #edf0f2; }
.management-row + .management-row { border-top: 1px solid #edf0f2; }
.management-info {
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-right: 10px;
}
.round-icon { flex: 0 0 28px; width: 28px; height: 28px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: white; font-size: 18px; }
.management-summary { flex: 1; min-width: 0; margin-left: 11px; display: grid; grid-template-columns: 1fr; gap: 2px; overflow: hidden; }
.management-summary .amount { display: block; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.management-summary strong { font-size: 14px; } .management-summary small, .transaction-item small { color: #8b919a; font-size: 11px; }
.amount { display: block; font-size: 13px; color: #377f68; font-weight: 500; }
.pay-amount { color: #5278ae; } .overdue-amount, .expense-amount { color: #d48735; }
.row-action {
  flex: 1 1 0;
  min-width: 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 0 10px 0 12px;
  border: 0;
  border-left: 1px solid #edf0f2;
  background: transparent;
  color: #424850;
  font-size: 12px;
  line-height: 1;
  text-align: left;
  white-space: nowrap;
}
.row-action span { color: #377f68; margin-right: 5px; } .pay-row .row-action span { color: #5278ae; }
.row-action b { flex: 0 0 auto; font-size: 20px; line-height: 1; color: #999fa8; font-weight: 300; }
.writeoff-card { padding: 0; }
.writeoff-actions { display: grid; grid-template-columns: 1fr 1fr; min-height: 58px; align-items: stretch; }
.writeoff-cell {
  display: flex;
  align-items: center;
  min-width: 0;
  cursor: pointer;
}
.writeoff-cell:active { background: #f7f8fa; }
.writeoff-cell-left {
  position: relative;
  justify-content: center;
  padding: 0 12px;
  border-right: 1px solid #e8eaed;
}
.writeoff-cell-right {
  justify-content: center;
  padding: 0 12px;
}
.writeoff-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  flex: 0 0 25px;
  width: 25px;
  height: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #5f63e9;
  background: rgba(95, 99, 233, 0.12);
}
.writeoff-icon svg { width: 16px; height: 16px; }
.writeoff-text {
  color: #363a42;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}
.section-title { display: flex; justify-content: space-between; align-items: center; }
.section-title button { border: 0; background: none; color: #397ce2; font-size: 12px; }
.transaction-list { display: grid; gap: 12px; }
.transaction-item {
  background: #fff; border: 1px solid #e5e7eb; border-radius: 5px;
  padding: 14px 12px; display: flex; align-items: center;
}
.transaction-icon { align-self: flex-start; width: 28px; height: 28px; border-radius: 50%; display: inline-flex; justify-content: center; align-items: center; font-size: 18px; margin-right: 10px; }
.income-icon { color: #3ba878; background: #e8f5ef; } .expense-icon { color: #e25b63; background: #fff0f0; }
.transaction-info { flex: 1; min-width: 0; display: grid; gap: 3px; } .transaction-info strong { font-size: 14px; font-weight: 500; }
.transaction-info small { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.transaction-no { color: #a5aab2; }
.transaction-value { flex: 0 0 auto; margin-left: 10px; text-align: right; display: grid; gap: 3px; } .transaction-value strong { font-size: 14px; }
.empty-state { background: #fff; border: 1px solid #e5e7eb; border-radius: 5px; text-align: center; color: #9aa0a8; font-size: 13px; padding: 28px 0; }
</style>
